import React from "react";

const LOGO_SRC = "/IMG/Logo_Icon.PNG";

export const AppLoader: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#E0F7F4] via-white to-[#ECFDF5]">
      <div className="text-center" role="status" aria-live="polite">
        <img
          src={LOGO_SRC}
          alt="GluviaCare+"
          className="w-14 h-14 mx-auto mb-4 object-contain"
        />

        <div className="flex justify-center">
          <div className="h-6 w-6 rounded-full border-2 border-gray-200 border-t-[#26B5AA] animate-spin" />
        </div>

        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default AppLoader;